export default __webpack_public_path__ + "static/media/email.e1ca3a72.svg";